import React from 'react';
import headerUnderline from '../assets/figma/header-underline.svg';

const bullets = [
  'Developed automated test scripts using BDD, Cucumber, TestNG, Appium, Java and LambdaTest.',
  'Maintained automated test modules for Domestic Remittance Service.',
  'Tested Aadhaar Enabled Payment Services (AePS) transaction workflows.',
  'Collaborated across dev and product teams for quality assurance.',
];

const technologies = ['Java', 'BDD', 'Cucumber', 'TestNG', 'Appium', 'LambdaTest'];

const Experience = () => (
  <section className="experience-section" id="experience-section">
    <div className="experience-content">
      <header className="experience-header">
        <div className="experience-kicker">
          <span className="experience-kicker-dot" />
          <span>Professional Experience</span>
        </div>
        <h2>Where I&apos;ve Worked</h2>
        <img className="experience-underline" src={headerUnderline} alt="" aria-hidden="true" />
      </header>

      <article className="experience-card">
        <div className="experience-card-meta">
          <div className="experience-role-company">
            <h3>Engineering Intern</h3>
            <div className="experience-company-row">
              <span>PayNearby</span>
              <span aria-hidden="true">•</span>
              <span>Mumbai</span>
            </div>
          </div>
          <span className="experience-duration">Jan 2026 - Jul 2026</span>
        </div>

        <ul className="experience-bullets">
          {bullets.map((bullet) => (
            <li key={bullet}>
              <span className="experience-bullet-dot" aria-hidden="true" />
              <p>{bullet}</p>
            </li>
          ))}
        </ul>

        <div className="experience-technologies" aria-label="Technologies used">
          {technologies.map((technology) => (
            <span className="experience-tech-pill" key={technology}>{technology}</span>
          ))}
        </div>
      </article>
    </div>
  </section>
);

export default Experience;
